import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => {
  return {
    formWrapper: {
      display: "grid",
      gap: "25px",
      maxWidth: "593px",
      width: "100%",
      margin: "20px auto",
    },
    actionBtns: {
      textTransform: "none",
    },

    customTableHeader: {
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "18px",
    },
    tableCellData: {
      color: theme.palette.text.secondary,
      fontWeight: 400,
      fontSize: "13px !important",
      lineHeight: "20px !important",
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    activeBox: {
      border: `1px solid ${theme.palette.success.main + "9A"}`,
      borderRadius: "6px",
      fontSize: "12px !important",
      padding: "0 8px",
      textTransform: "capitalize",
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "20px",
      background: theme.palette.success.main + "1A",
    },
    inactiveBox: {
      border: `1px solid ${theme.palette.error.main + "9A"}`,
      borderRadius: "6px",
      fontSize: "12px !important",
      padding: "0 8px",
      textTransform: "capitalize",
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "20px",
      background: theme.palette.error.main + "1A",
    },
    searchBar: {
      "& input": {
        fontSize: "13px",
        fontWeight: 400,
        color: "#00000099 !important",
      },
      "& .MuiSvgIcon-root": {
        color: "#00000029",
      },
      "& .MuiInputBase-input::placeholder": {
        color: "#00000099",
      },
    },
    versionChip: {
      display: "flex",
      gap: 1,
      alignItems: "center",
      justifyContent: "center",
      height: "23px",
      width: "40px",
      borderRadius: "16px",
      padding: "2px 8px",
    },
    roleBox: {
      border: "1px solid #D6D6D6",
      borderRadius: "4px",
      fontSize: "12px !important",
      padding: "0 10px",
      textTransform: "capitalize",
      minWidth: "107px",
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "20px !important",
      color: "#878787",
      background: "#FFFFFF",
    },
  };
});
export const getPlayerStyles = () => {
  const styleElement = document.createElement("style");
  styleElement.textContent = `
    .rr-controller {
      width: 100% !important;
      height: 50px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      
      z-index: 100 !important;
      visibility: visible !important;
      opacity: 1 !important;
      background: transparent !important;
    }
    
    .rr-progress {
      flex: 1 !important;
      height: 12px !important;
      cursor: pointer !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    
    .rr-controller__btns {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    
    .rr-controller__btns button {
      margin: 0 5px !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    
    .rr-player {
      width: 100% !important;
      height: 100% !important;
    }
    
    .rr-player__frame {
      width: 100% !important;
      height: calc(100% - 40px) !important;
    }
    
    .replayer-wrapper {
      width: 100% !important;
      height: 100% !important;
    }

    /* Fullscreen styles for when the video player is in fullscreen mode */
    .video-player-container.fullscreen-mode {
      width: 100vw !important;
      height: 100vh !important;
      background: black !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      z-index: 999999 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .video-player-container.fullscreen-mode .rr-player {
      width: 100% !important;
      height: 100% !important;
      max-width: 100vw !important;
      max-height: 100vh !important;
      position: relative !important;
    }
    
    .video-player-container.fullscreen-mode .rr-player__frame {
      width: 100% !important;
      height: calc(100% - 60px) !important;
      position: relative !important;
    }
    
    .video-player-container.fullscreen-mode .replayer-wrapper {
      width: 100% !important;
      height: 100% !important;
      transform: scale(1) !important;
      position: relative !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .video-player-container.fullscreen-mode .rr-controller {
      position: fixed !important;
      bottom: 20px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      z-index: 1000000 !important;
      
      border-radius: 8px !important;
      padding: 10px !important;
      width: 80% !important;
    }

    .video-player-container.fullscreen-mode iframe {
      width: 100% !important;
      height: 100% !important;
      border: none !important;
      position: relative !important;
    }

    /* Rest of your existing styles... */
    .resizer {
      width: 5px;
      cursor: col-resize;
      height: 100%;
      background-color: #e0e0e0;
      transition: background-color 0.2s;
    }
    
    .resizer:hover, .resizer.dragging {
      background-color: #2196f3;
    }

    .panel-resizer {
      cursor: col-resize;
      background-color: #e0e0e0;
      transition: background-color 0.2s;
    }
    
    .panel-resizer:hover, .panel-resizer.dragging {
      background-color: #2196f3;
    }

    .code-highlight {
      font-family: 'Consolas', 'Courier New', monospace;
      background-color: #f5f5f5;
      border-radius: 4px;
      padding: 0 4px;
      font-size: 0.85em;
      color: #D32F2F;
    }

    .attr-name {
      color: #7B1FA2;
    }

    .attr-value {
      color: #1976D2;
    }
    
    .assertion-category {
      font-weight: 600;
      color: #6366f1;
      margin-bottom: 4px;
      padding: 4px 8px;
      background-color: rgba(99, 102, 241, 0.08);
      border-radius: 4px;
    }
    
    .audio-indicator {
      position: absolute;
      top: 25px;
      right: 80px;
      background-color: rgba(0, 0, 0, 0.6);
      color: white;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 4px;
      z-index: 1000000;
      cursor: pointer;
      transition: background-color 0.2s;
    }

    .audio-indicator:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }

    .audio-visualizer {
      position: absolute;
      bottom: 60px;
      left: 10px;
      right: 10px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000000;
    }
    
    .audio-bar {
      width: 3px;
      margin: 0 1px;
      background-color: #4caf50;
      border-radius: 1px;
      transition: height 0.1s ease;
    }
    
    .audio-buffering-indicator {
      position: absolute;
      bottom: 60px;
      left: 50%;
      transform: translateX(-50%);
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 4px 12px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      z-index: 1000000;
    }
    
    .audio-error-message {
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      background-color: rgba(211, 47, 47, 0.9);
      color: white;
      padding: 6px 12px;
      border-radius: 4px;
      font-size: 14px;
      z-index: 1000000;
      max-width: 80%;
      text-align: center;
    }

    /* Console and debug panel styles */
    .console-log-entry {
      font-family: 'Consolas', 'Courier New', monospace;
      font-size: 12px;
      line-height: 1.4;
      border-bottom: 1px solid #f1f3f4;
    }

    .console-timestamp {
      color: #5f6368;
      font-size: 11px;
    }

    .console-error {
      background-color: #fff8e1;
      border-left: 3px solid #e91e63;
    }

    .console-warn {
      background-color: #fff3e0;
      border-left: 3px solid #ff9800;
    }

    .console-log {
      background-color: #f8f9fa;
      border-left: 3px solid #4caf50;
    }

    .network-request-item {
      border-bottom: 1px solid #e0e0e0;
      transition: background-color 0.2s;
    }

    .network-request-item:hover {
      background-color: #f5f5f5;
    }

    .network-request-method {
      font-weight: bold;
      padding: 2px 6px;
      border-radius: 3px;
      font-size: 11px;
    }

    .network-method-get {
      background-color: #4caf50;
      color: white;
    }

    .network-method-post {
      background-color: #2196f3;
      color: white;
    }

    .network-method-put {
      background-color: #ff9800;
      color: white;
    }

    .network-method-delete {
      background-color: #f44336;
      color: white;
    }

    .status-success {
      color: #4caf50;
      font-weight: bold;
    }

    .status-redirect {
      color: #ff9800;
      font-weight: bold;
    }

    .status-error {
      color: #f44336;
      font-weight: bold;
    }

    .action-item {
      border-bottom: 1px solid #e0e0e0;
      transition: background-color 0.2s;
    }

    .action-item:hover {
      background-color: #e3f2fd;
    }

    .action-timestamp {
      font-family: 'Consolas', 'Courier New', monospace;
      font-size: 11px;
      color: #666;
    }

    .debug-panel-content::-webkit-scrollbar {
      width: 8px;
    }

    .debug-panel-content::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    .debug-panel-content::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
    }

    .debug-panel-content::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }

    .filter-chip {
      transition: all 0.2s ease;
      cursor: pointer;
    }

    .filter-chip:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    }

    .expandable-content {
      transition: max-height 0.3s ease;
      overflow: hidden;
    }

    button:hover {
      opacity: 0.8;
      transition: opacity 0.2s;
    }

    button:focus,
    input:focus,
    select:focus {
      outline: 2px solid #2196f3;
      outline-offset: 2px;
    }

    @media print {
      .video-player-container {
        display: none !important;
      }
      
      .debug-panel {
        page-break-inside: avoid;
      }
    }

    @media (prefers-contrast: high) {
      .rr-controller {
        background-color: black !important;
        border: 2px solid white !important;
      }
      
      .audio-indicator {
        background-color: black !important;
        border: 1px solid white !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      * {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
      }
    }

    @media (prefers-color-scheme: dark) {
      .console-log-entry {
        background-color: #1e1e1e;
        color: #e0e0e0;
      }
      
      .network-request-item {
        background-color: #2d2d2d;
        color: #e0e0e0;
      }
      
      .action-item {
        background-color: #2d2d2d;
        color: #e0e0e0;
      }
    }

    @media (max-width: 768px) {
      .video-player-container.fullscreen-mode .rr-controller {
        bottom: 10px !important;
        padding: 8px !important;
        max-width: 95% !important;
      }
      
      .audio-indicator {
        top: 5px !important;
        right: 5px !important;
        font-size: 10px !important;
        padding: 2px 6px !important;
      }
      
      .rr-controller__btns button {
        margin: 0 2px !important;
        padding: 4px !important;
      }
    }

    @media (max-width: 1024px) and (min-width: 769px) {
      .video-player-container.fullscreen-mode .rr-controller {
        bottom: 15px !important;
        max-width: 90% !important;
      }
    }
  `;
  return styleElement;
};
